export default "__VITE_ASSET__Dxs5M8XW__"